import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ITutor, ITutorCalenderSlot } from '@wot/typings'
import tutorProfileApi, { PUdateProfile } from "../api/profile";
import { toast } from "react-toastify";

interface IInitalState {
  profile: ITutor | null,
  loading: boolean,
  error: string,
}

const initalState: IInitalState = {
  profile: null,
  loading: false,
  error: ""
}

export const getTutorProfile = createAsyncThunk("getTutorProfile", async (accountId: string, { fulfillWithValue, rejectWithValue }) => {
  const res = await tutorProfileApi.getByAccountId(accountId);
  if (res.status === "OK") {
    return fulfillWithValue(res.data)
  } else {
    rejectWithValue(res.message);
  }
})
export const updateCalender = createAsyncThunk("updateCalender", async (data: ITutorCalenderSlot[], { fulfillWithValue, rejectWithValue, getState }) => {
  // @ts-ignore
  const { profile } = getState().profileSlice
  const res = await tutorProfileApi.updateCalender(profile._id, data);
  if (res.status === "OK") {
    return fulfillWithValue(res.data)
  } else {
    rejectWithValue(res.message);
  }
})

export const updateProfile = createAsyncThunk("updateProfile", async (data: PUdateProfile, { fulfillWithValue, rejectWithValue, getState }) => {
  // @ts-ignore
  const { profile } = getState().profileSlice
  try {
    const res = await tutorProfileApi.updateProfile(profile._id, data);
    if (res.status === "OK") {
      toast.success("Profile Updated successfully")
      return fulfillWithValue(res.data)
    }
  } catch (err) {
    rejectWithValue(err);
  }
})

const profileSlice = createSlice({
  name: "profileSlice",
  initialState: initalState,
  reducers: {
    setUserProfile: (state, action) => {
      console.log(action.payload);
      state.profile = action.payload
    }
  },
  extraReducers(builder) {
    builder.addCase(getTutorProfile.pending, (state, action) => {
      state.loading = true;
      state.error = "";
    })
    builder.addCase(getTutorProfile.fulfilled, (state, action) => {
      // @ts-ignore
      state.profile = action.payload;
      state.error = "";
      state.loading = false;
    })
    builder.addCase(getTutorProfile.rejected, (state, action) => {
      // @ts-ignore
      state.error = action.payload;
      state.loading = false;
    })

    builder.addCase(updateCalender.pending, (state, action) => {
      state.loading = true;
      state.error = "";
    })
    builder.addCase(updateCalender.fulfilled, (state, action) => {
      // @ts-ignore
      state.profile = {
        ...state.profile,
        calender: action.payload
      };
      state.error = "";
      state.loading = false;
    })
    builder.addCase(updateCalender.rejected, (state, action) => {
      // @ts-ignore
      state.error = action.payload;
      state.loading = false;
    })

    builder.addCase(updateProfile.pending, (state, action) => {
      state.loading = true;
      state.error = "";
    })
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      // @ts-ignore
      state.profile = {
        ...state.profile,
        ...action.payload
      };
      state.error = "";
      state.loading = false;
    })
    builder.addCase(updateProfile.rejected, (state, action) => {
      // @ts-ignore
      state.error = action.payload;
      state.loading = false;
    })
  },

})

export const { setUserProfile } = profileSlice.actions
export default profileSlice.reducer